import _taggedTemplateLiteral from '../../../../node_modules/@babel/runtime/helpers/taggedTemplateLiteral.es.js';
import { styled, keyframes, css } from '@mgmresorts/wcl-styled';
import '../../../../node_modules/styled-system/dist/index.esm.es.js';
import { space } from '../../../../node_modules/@styled-system/space/dist/index.esm.es.js';

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
var StyledIESpinner = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n"])), space);
var load8 = keyframes(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n"])));
var ieSpinnerAnimation = css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", " 1.1s infinite linear;\n"])), load8);
var IESpinner = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  margin: 60px auto;\n  position: relative;\n  text-indent: -9999em;\n  border-top: 0.2rem solid ", ";\n  border-right: 0.2rem solid ", ";\n  border-bottom: 0.2rem solid ", ";\n  border-left: 0.2rem solid ", ";\n  -webkit-transform: translateZ(0);\n  -ms-transform: translateZ(0);\n  transform: translateZ(0);\n  -webkit-animation: ", ";\n  animation: ", ";\n\n  border-radius: 50%;\n  width: ", ";\n  height: ", ";\n\n  &:after {\n    border-radius: 50%;\n    width: ", ";\n    height: ", ";\n  }\n"])), function (p) {
  return p.colorWithOpacity;
}, function (p) {
  return p.colorWithOpacity;
}, function (p) {
  return p.colorWithOpacity;
}, function (p) {
  return p.solidColor;
}, ieSpinnerAnimation, ieSpinnerAnimation, function (p) {
  return p.size;
}, function (p) {
  return p.size;
}, function (p) {
  return p.size;
}, function (p) {
  return p.size;
});
var StyledIcon = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  color: ", ";\n  height: ", ";\n\n  // for iOS\n  circle {\n    stroke: ", " !important;\n  }\n\n  ", "\n"])), function (p) {
  return "".concat(p.size, "px");
}, function (p) {
  return p.color || p.theme.colors["interface"];
}, function (p) {
  return "".concat(p.size, "px");
}, function (p) {
  return p.color || p.theme.colors["interface"];
}, function (p) {
  return p.strokeWidth && "\n      circle {\n        stroke-width: ".concat(p.strokeWidth, ";\n      }\n    ");
});

export { IESpinner, StyledIESpinner, StyledIcon, ieSpinnerAnimation, load8 };
